import React, { Fragment } from "react";

export default () => {
  const processorData = [
    { option: "PROCESSOR OPTIONS:", value: "", disabled: true },
    { option: "Advanced Meat Processing", value: "P010" },
    { option: "Arkansas Meats", value: "P013" },
    { option: "B & R Meat Processing", value: "P026" },
    { option: "Big Ed's", value: "P004" },
    { option: "Black's", value: "P017" },
    {
      option: "Cartmell's Wild Game Meat Processing",
      value: "P020"
    },
    { option: "Clinton Meat Processor", value: "P025" },
    { option: "Cockrum's", value: "P009" },
    { option: "Deaton Slaughterhouse", value: "P022" },
    { option: "Gooseneck", value: "P012" },
    { option: "Griffith", value: "P016" },
    {
      option: "Harold's Taxidermy and Processing",
      value: "P005"
    },
    { option: "J and D", value: "P024" },
    { option: "James Tilley", value: "P003" },
    { option: "JNL Processing", value: "P011" },
    { option: "Keith Harty", value: "P014" },
    { option: "Makin' Bacon", value: "P021" },
    { option: "Marsolf's", value: "P030" },
    { option: "McCormick's One Stop", value: "P018" },
    {
      option: "Miller's Arkansas Quality Processors",
      value: "P028"
    },
    { option: "Mt. View", value: "P031" },
    { option: "Newton's", value: "P007" },
    { option: "Ozark Custom Butchering", value: "P027" },
    { option: "Scranton Processing", value: "P019" },
    { option: "Siloam Springs Processing", value: "P006" },
    { option: "Tammie Phillips ", value: "P101" },
    { option: "The Butcher Shop", value: "P002" },
    {
      option: "Tilton's Wildgame Processing",
      value: "P008"
    },
    { option: "Twin Lakes", value: "P001" },
    { option: "Wild Game Processing", value: "P029" },
    { option: "TAXIDERMY OPTIONS:", value: "", disabled: true },

    { option: "Black River Taxidermy", value: "T011" },
    { option: "Chief's Taxidermy", value: "T001" },
    { option: "Chris Roberts Taxidermy", value: "T059" },
    { option: "CJ's Taxidermy", value: "T006" },
    { option: "Crowley's Ridge Taxidermy", value: "T027" },
    { option: "Cupped 'N' Committed Taxidermy", value: "T019" },
    { option: "European Mounts Taxidermy", value: "T030" },
    { option: "Faughn’s Taxidermy", value: "T035" },
    { option: "Foust TAXIDERMY", value: "T028" },
    { option: "Harolds Taxidermy", value: "T007" },
    { option: "Hi-Tech Taxidermy", value: "T052" },
    { option: "Hilltop Taxidermy", value: "T008" },
    { option: "Jones Creek Taxidermy", value: "T042" },
    { option: "Karen's Taxidermy", value: "T009" },
    { option: "Manly's Taxidermy", value: "T032" },
    { option: "McFarlan's Taxidermy", value: "T010" },
    { option: "Mike Hughes Taxidermy", value: "T025" },
    { option: "Mike Taxidermy", value: "T034" },
    { option: "Palmer's Taxidermy", value: "T053" },
    { option: "Payton Usrey's Taxidermist", value: "T049" },
    { option: "Phillips' Taxidermy", value: "T051" },
    { option: "Primm Taxidermy", value: "T014" },
    { option: "Pruitt Taxidermy", value: "T002" },
    { option: "Raby's Taxidermy", value: "T018" },
    { option: "Rack Down Taxidermy", value: "T055" },
    { option: "Randy Moore Taxidermy", value: "T029" },
    { option: "Rick's Taxidermy", value: "T015" },
    { option: "Rocking W Taxidermy", value: "T054" },
    { option: "Roger's Taxidermy", value: "T058" },
    { option: "Roy's Taxidermy", value: "T036" },
    { option: "Smiths Taxidermy", value: "T046" },
    { option: "Snowball Taxidermy", value: "T050" },
    { option: "Spencer's Taxidermy", value: "T038" },
    { option: "Starvation Acres Taxidermy", value: "T062" },
    { option: "Stone's Taxidermy", value: "T023" },
    { option: "Tags Taxidermy", value: "T031" },
    { option: "Tim's European Mounts Taxidermy", value: "T026" },
    { option: "Transformation Taxidermy", value: "T061" },
    { option: "Traywick's Taxidermy", value: "T037" },
    { option: "Unlimited Taxidermy", value: "T057" },
    { option: "Wewers Taxidermy", value: "T022" },
    { option: "Wild Things Taxidermy", value: "T064" },
    { option: "Wildlife Images Taxidermy", value: "T043" },
    { option: "Wylie's Taxidermy", value: "T048" }
  ];

  return (
    <Fragment>
      <option />
      {processorData.map((l, i) => (
        <option key={i} value={l.value} disabled={l.disabled}>
          {l.option}
        </option>
      ))}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/wizardSection/renderProcessorOptions.jsx